/* Bootstrap only. Excluded from coverage in vite.config.ts because it does nothing but mount —
   there is no logic here to assert, and a test that mounts the real root would be an e2e test
   wearing a unit test's clothes. */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './theme/tokens.css';
import './theme/app.css';
import { App } from './App';
import { canonicalUrl } from './lib/canonicalHost';

/* One address for the console. See `lib/canonicalHost.ts` — it is a redirect, not a control. */
const canonical = canonicalUrl(window.location);
if (canonical) window.location.replace(canonical);

const el = document.getElementById('root');
/* v8 ignore next -- index.html always provides #root; this guard exists so a missing mount
   point fails with a sentence instead of "Cannot read properties of null". */
if (!el) throw new Error('#root is missing from index.html');
createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
